import { isQueryTraceSupported, queryTraceHeaders } from '@/lib/queryTrace';
import axios from 'axios';
import { clearAuthSession } from '@/store/authStore';

const client = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

// Her istekte localStorage'daki token'ı ekle
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['x-client-type'] = 'web';
  if (!isQueryTraceSupported()) config.headers['x-query-trace-disabled'] = 'true';
  if (!String(config.url).includes('/monitoring/session-trace')) {
    for (const [key, value] of Object.entries(queryTraceHeaders())) config.headers[key] = value;
  }
  return config;
});

// 401 gelirse token'ı temizle ve login'e yönlendir
client.interceptors.response.use(
  (res) => res,
  (err) => {
    const requestUrl = String(err.config?.url ?? '');
    const isLoginRequest = requestUrl.includes('/auth/login');

    if (err.response?.status === 401 && !isLoginRequest) {
      clearAuthSession();
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }
    return Promise.reject(err);
  }
);

export default client;
